import Request from '../../../util/Api';
import Cookie from 'react-cookies';
import Config from '../../../util/Configuration';

import { push } from 'connected-react-router';

import {
    loginThunks, loginActionIds,
    logoutThunks, logoutActionIds,
    profileActionIds, twoFactorThunks,
} from './Constants';

import User from '../../../structures/User';

import { setLoading, unsetLoading } from '../../common/Loading/Actions';

import { toaster } from 'evergreen-ui';



const ENDPOINT_AUTHENTICATE = '/account/authenticate';
const ENDPOINT_AUTHENTICATE_GOOGLE = '/account/authenticate-google';
const ENDPOINT_DEAUTHENTICATE = '/account/deauthenticate';
const ENDPOINT_PROFILE = '/account';
const ENDPOINT_TWO_FACTOR_VERIFY = '/v2/auth/two-factor/verify';
const ENDPOINT_TWO_FACTOR_RESEND = '/v2/auth/two-factor/resend';

// Shared tail of both login steps: persist the session cookie and enter the app.
function completeLogin(dispatch, result, rememberMe) {
    const maxAge = rememberMe ? Config.sessionMaxAgeRemember : Config.sessionMaxAge;

    Cookie.save('nax-session', result.token, {
        maxAge,
        path: "/"
    });

    dispatch(loginThunks.success(result));
    dispatch(push('/'));
}

export function checkAuth() {
    return async (dispatch, getState) => {

        const session = Cookie.load('nax-session');

        if (!session && getState().router.location === "/login") {
            return;
        } else if (!session) {
            dispatch(push('/login'));
            return;
        }

        dispatch(loginThunks.success({
            token: session
        }));

        dispatch(setLoading(profileActionIds.request));

        try {
            const result = await Request.get(ENDPOINT_PROFILE);

            dispatch(loginThunks.success({
                token: session,
                user: new User(result.user)
            }));
        } catch (e) {
            dispatch(push('/login'));
            dispatch(loginThunks.failure());
            await dispatch(logout());
        }

        dispatch(unsetLoading(profileActionIds.request));
    }
}

export function login(opts) {
    return async (dispatch) => {
        dispatch(setLoading(loginActionIds.request));
        dispatch(loginThunks.request());

        try {
            let result = await Request.post(ENDPOINT_AUTHENTICATE, null, null, {
                email: opts.email,
                password: opts.password,
                admin: true
            });

            if (result.twoFactorRequired) {
                // No session yet — the API sent a code (email by default,
                // SMS when re-enabled server-side); stash the challenge and
                // let the login page swap to the code form.
                dispatch(twoFactorThunks.request({
                    challengeToken: result.challengeToken,
                    hint: result.hint,
                    channel: result.channel,
                    rememberMe: opts.rememberMe
                }));
            } else {
                completeLogin(dispatch, result, opts.rememberMe);
            }
        } catch (err) {
            if (err && err.message === 'two_factor_no_phone') {
                toaster.danger('Contul nu are un numar de telefon setat. Cere unui administrator sa il adauge.');
            } else if (err && err.message === 'two_factor_throttled') {
                toaster.danger('Prea multe incercari. Asteapta 30 de secunde si reincearca.');
            } else {
                toaster.danger('Email sau parola incorecte.');
            }
            dispatch(loginThunks.failure(err));
        }

        dispatch(unsetLoading(loginActionIds.request));
    }
}

export function verifyTwoFactor(code) {
    return async (dispatch, getState) => {
        const twoFactor = getState().authentication.twoFactor;
        if (!twoFactor) {
            return;
        }

        dispatch(setLoading(loginActionIds.request));

        try {
            const result = await Request.post(ENDPOINT_TWO_FACTOR_VERIFY, null, null, {
                token: twoFactor.challengeToken,
                code
            });

            completeLogin(dispatch, result, twoFactor.rememberMe);
        } catch (err) {
            toaster.danger('Cod incorect sau expirat. Incearca din nou sau cere un cod nou.');
        }

        dispatch(unsetLoading(loginActionIds.request));
    }
}

export function resendTwoFactorCode() {
    return async (dispatch, getState) => {
        const twoFactor = getState().authentication.twoFactor;
        if (!twoFactor) {
            return;
        }

        try {
            await Request.post(ENDPOINT_TWO_FACTOR_RESEND, null, null, {
                token: twoFactor.challengeToken
            });
            toaster.success(twoFactor.channel === 'sms'
                ? 'Ti-am trimis un cod nou prin SMS.'
                : 'Ti-am trimis un cod nou pe email.');
        } catch (err) {
            if (err && err.message === 'two_factor_throttled') {
                toaster.danger('Ai cerut deja un cod. Asteapta 30 de secunde intre trimiteri.');
            } else {
                // Challenge expired server-side — restart from the password step.
                toaster.danger('Sesiunea de verificare a expirat. Autentifica-te din nou.');
                dispatch(twoFactorThunks.failure());
            }
        }
    }
}

export function cancelTwoFactor() {
    return (dispatch) => {
        dispatch(twoFactorThunks.failure());
    }
}

export function loginWithGoogle(credential) {
    return async (dispatch) => {
        if (!credential) {
            toaster.danger('Autentificarea Google a esuat. Te rog incearca din nou.');
            return;
        }

        dispatch(setLoading(loginActionIds.request));
        dispatch(loginThunks.request());

        try {
            let result = await Request.post(ENDPOINT_AUTHENTICATE_GOOGLE, null, null, {
                token: credential
            });

            Cookie.save('nax-session', result.token, {
                maxAge: Config.sessionMaxAgeRemember,
                path: "/"
            });

            dispatch(loginThunks.success(result));
            dispatch(push('/'));
        } catch (err) {
            toaster.danger('Cont neautorizat sau inexistent.');
            dispatch(loginThunks.failure(err));
        }

        dispatch(unsetLoading(loginActionIds.request));
    }
}

export function logout() {
    return async (dispatch) => {
        dispatch(setLoading(logoutActionIds.request));
        dispatch(logoutThunks.request());

        try {
            await Request.post(ENDPOINT_DEAUTHENTICATE);
            Cookie.remove('nax-session', { patch: '/' });
            toaster.success('Esti delogat din aplicatie');
            dispatch(logoutThunks.success());
            dispatch(push('/login'));
        } catch (err) {
            dispatch(logoutThunks.failure());
            toaster.danger('A fost o problema cu delogarea. Te rog incearca din nou');
        }

        dispatch(unsetLoading(logoutActionIds.request));
    }
}